// import axios from "axios";

// let baseURL;
// const env = "stage"
// if (env === 'production') {
//     baseURL = 'https://api.salvussequr.com';
// } else if (env === 'stage') {
//     baseURL = 'https://stage.salvussequr.com';
// } else if (env === 'development') {
//     baseURL = 'http://localhost:5000';
// } else {
//     baseURL = 'https://api.salvussequr.com';
// }

// export const API = axios.create({
//     baseURL: baseURL,
//     headers: {
//         key: '7f8c9d6a1b2e3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8'
//     }
// });

import axios from "axios";

const API_KEY =
  "7f8c9d6a1b2e3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8";

// Static assets (QR/barcode images) still need the real backend host.
const baseURL =
  process.env.REACT_APP_SERVER_API || "http://127.0.0.1:8003";

// In dev, API calls go through CRA proxy (setupProxy.js) on same origin.
const apiBaseURL = process.env.NODE_ENV === "development" ? "" : baseURL;

export const API = axios.create({
  baseURL: apiBaseURL,
  headers: {
    key: API_KEY,
  },
});

export { baseURL };

export const PRODUCT_API = {
    GET_LIST: `/api/v1/get-products`,
    ADD_PRODUCT: `/api/v2/addProduct`,
    DELETE_PRODUCT: `/api/v1/delete-product`
}

export const USER_API = {
    GET_LIST: `/api/v1/get-users`,
    DELETE_USER: `/api/v1/delete-user`,
    GET_USER_PRODUCT: `/api/v1/get-user-product`,
    Archive_USER: `/api/v1/archive-user`,
}

export const HELP_API = {
    GET_LIST: `/api/v1/get-user-issue`,
    GET_ISSUE_CATEGORY_LIST: `/api/v1/get-help-category`,
    CREATE_ISSUE_CATEGORY: `/api/v1/add-help-category`,
}

export const EVENT_API = {
    GET_LIST: `/api/v1/get-event-records-by-email`,
    GET_ALL_EVENTS: `/api/v1/live-events`, 
    GET_USER_BY_ID: `/api/v1/get-user-by-id`,

}

export const DASHBOARD_API = {
    GET_COUNTS: `/api/v1/get-dashboard-counts`,
    GET_CHART_DATA: `/api/v1/get-user-chart-data`,
    REASON_TO_DELETE: `/api/v1/common-reason-user-delete-app`,
    GET_EVENTS_BY_LOCATION: `/api/v1/get-events-by-location`,
    GET_USER_BY_LOCATION: `/api/v1/search-users-by-location`
}

export const ADMIN_API = {
    CONSOLE_OVERVIEW: `/api/v1/admin-console-overview`,
}




export const QR_AUTH_API = {
    GET_GENERATE_QR: `/auth/generate-qr`,
    GET_CHECK_TOKEN: `/auth/check`,
}

export const SECAR_PAYMENT = {
    CLOSE_PAYMENT_WINDOW: `/api/v1/close-payment-window`,
}